/** Word default body text (11pt), scaled for DOCX export only (not UI textfields). */
const DOCX_BASE_FONT_SIZE_PT = 11;
export const DOCX_EXPORT_FONT_SIZE_SCALE = 1.4;

export function getDocxExportFontSizeHalfPoints(): number {
  return Math.round(DOCX_BASE_FONT_SIZE_PT * DOCX_EXPORT_FONT_SIZE_SCALE * 2);
}
